<template>
    <div>
        <label class="label">Files</label>
        <div class="list is-hoverable">
            <a
                class="list-item"
                v-for="(file,key) in fileList"
                :key="file.id ? file.id : key"
                >
                <span
                    v-if="id" @click.prevent="downloadFile(file)">
                    {{ file.attributes.name }}
                </span>
                <span v-else>{{file.name}}</span>
                <b-icon class="is-pulled-right" icon="download" v-if="id" @click.prevent="downloadFile(file)"></b-icon>
                <b-icon class="is-pulled-right" icon="close-circle" @click.native="remove(file,key)"></b-icon>
            </a>
        </div>

        <b-upload v-model="files" multiple class="is-pulled-right m-b-sm">
            <a class="button is-primary">
                <b-icon icon="upload"></b-icon>
                <span>Upload New Files</span>
            </a>
        </b-upload>
        <br>
    </div>
</template>
<script>
import Vue from "vue";

export default {
    props: ["ticketFiles"],
    data() {
        return {
            fileList: [],
            files: []
        };
    },
    computed: {
        loading: {
            get() {
                return this.$store.state.loading;
            },
            set(value) {
                this.$store.commit("SET_LOADING", value);
            }
        },
        id(){
            return this.$route.params.id
        }
    },
    watch: {
        ticketFiles() {
            this.fileList = this.ticketFiles;
        },
        async files(values) {
            let files = this.fileReader(values);
            if (files.length > 0) {
                this.uploadFiles(files);
            }
        }
    },
    methods: {
        async uploadFiles(files) {
            this.loading = true;
            let formData = new FormData();
            await files.forEach(file => {
                formData.append("files[]", file);
            });

            if(!this.$route.params.id){
                this.$emit('upload',formData)
                this.fileList = formData.getAll('files[]');
                this.loading = false
                return;
            }
            Vue.$ticketService
                .uploadFiles(this.$route.params.id, formData)
                .then(response => {
                    if (response.included) {
                        this.loading = false
                        this.fileList = response.included.filter(
                            include => include.type == "files"
                        );
                        this.files = [];
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        fileReader(files) {
            let results = [];
            files.forEach(file => {
                var reader = new FileReader();
                reader.onload = e => {
                    this.imageSrc = e.target.result;
                };
                if (file) {
                    reader.readAsDataURL(file);
                    results.push(file);
                }
            });
            return results;
        },
        async downloadFile(file) {
            const a = document.createElement("a");
            console.log(this.id)
            a.href = await this.toDataURL(file.attributes.path);
            a.download = file.attributes.name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        toDataURL(url) {
            return fetch(url)
                .then(response => {
                    return response.blob();
                })
                .then(blob => {
                    return URL.createObjectURL(blob);
                });
        },
        async remove(file,key){
            if(this.id){
                this.$buefy.dialog.confirm({
                title:'Are you sure?',
                message:'Are you sure you want to <strong>DELETE</strong> this file? This action cannot be undone.',
                type:'is-danger',
                onConfirm:async ()=>{
                        let data = {
                            ids:[file.id]
                        }
                        await Vue.$ticketService.deleteFile(this.id,data).then(()=>{
                            this.$buefy.toast.open({
                                message:'File deleted!',
                                type:'is-success'
                            })
                        }).catch(err=>{
                            console.error(err)
                            return;
                        })
                    }
                });
            }
            this.fileList = await this.fileList.filter((element,index)=>{
                return index!==key
            })
            this.files = await this.files.filter((element,index)=>{
                return index!==key
            })
        }
    }
};
</script>